module.exports = __webpack_public_path__ + "img/ECU_for_Nissan_Leaf4.7b1dc872.jpg";